
import { Skeleton } from '@material-ui/lab';

/**
 * Reusable Component for the Dynamic Template Counts
 * Handles toggling between Skeleton and Real Data
 */
const TemplateStatCard = ({ icon: Icon, label, count, loading, customIconClass, isTotal }) => {
    return (
        <div className={`template-card ${isTotal ? 'total-card' : ''}`}>
            <div className={`template-icon ${customIconClass || ''} ${isTotal ? 'total-icon' : ''}`}>
                <Icon fontSize='inherit' />
            </div>
            <div className="template-label">{label}</div>
            <div className={`template-count ${isTotal ? 'total-count' : ''}`}>
                {loading ? (
                    <Skeleton variant="rect" width={40} height={28} style={{ borderRadius: 4 }} animation="wave" />
                ) : (
                    count || 0
                )}
            </div>
        </div>
    );
};

export default TemplateStatCard;